<template>
  <div>
    
       <!-- Became A -->
    <div class="becamea-container">
      <div class="container ba-bb">
        <div class="row">
          
          <div class="col-lg-4 col-md-6">
            <div class="ba-card">
              <img v-if="row.image5" :src="row.image5" class="img-fluid" :alt="row.title5" />
              <div class="ba-details">
                <div class="title mb-3"
                  v-html="row.title5"
                  :style="'color:'+row.titleColor5+' !important'">
                </div>
                <router-link v-if="row.button5" :to="row.redirect5"
                  class="btn-line">{{ row.button5 }} <span class="line"></span>
                </router-link>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="ba-card">
              <img v-if="row.image6" :src="row.image6" class="img-fluid" :alt="row.title6" />
              <div class="ba-details">
                <div class="title mb-3"
                  v-html="row.title6"
                  :style="'color:'+row.titleColor6+' !important'">
                </div>
                <router-link v-if="row.button6" :to="row.redirect6"
                  class="btn-line">{{ row.button6 }} <span class="line"></span>
                </router-link>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="ba-card">
              <img v-if="row.image7" :src="row.image7" class="img-fluid" :alt="row.title7" />
              <div class="ba-details">
                <div class="title mb-3"
                  v-html="row.title7"
                  :style="'color:'+row.titleColor7+' !important'">
                </div>
                <router-link v-if="row.button7" :to="row.redirect7"
                  class="btn-line">{{ row.button7 }} <span class="line"></span>
                </router-link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- Became A -->

  </div>
</template>

<script>
export default {
  name: "Section2",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
